var _circle, _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoBudget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.25,
    cy: 20.5,
    r: 19,
    stroke: "#7663EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 34L33.75 7",
    stroke: "#7663EB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.25,
    y: 11.75,
    width: 15,
    height: 16.875,
    rx: 4.375,
    stroke: "#7663EB",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8744 14.25C23.2196 14.25 23.5053 14.5317 23.448 14.8721C23.4012 15.1504 23.323 15.4231 23.2145 15.6851C23.0261 16.14 22.7499 16.5534 22.4017 16.9017C22.0534 17.2499 21.64 17.5261 21.1851 17.7145C20.7301 17.903 20.2425 18 19.75 18C19.2575 18 18.7699 17.903 18.3149 17.7145C17.86 17.5261 17.4466 17.2499 17.0983 16.9017C16.7501 16.5534 16.4739 16.14 16.2855 15.6851C16.177 15.4231 16.0988 15.1504 16.052 14.8721C15.9947 14.5317 16.2804 14.25 16.6256 14.25C16.9708 14.25 17.2435 14.5341 17.329 14.8685C17.3583 14.9834 17.3958 15.0962 17.4414 15.2063C17.567 15.5094 17.751 15.7849 17.9831 16.0169C18.2151 16.249 18.4906 16.433 18.7937 16.5586C19.0969 16.6842 19.4219 16.7488 19.75 16.7488C20.0781 16.7488 20.4031 16.6842 20.7063 16.5586C21.0094 16.433 21.2849 16.249 21.5169 16.0169C21.749 15.7849 21.933 15.5094 22.0586 15.2063C22.1042 15.0962 22.1417 14.9834 22.171 14.8685C22.2565 14.5341 22.5292 14.25 22.8744 14.25Z",
    fill: "#7663EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBudget);
export default __webpack_public_path__ + "static/media/no-budget.a9ddde259fc7845276c5c4b6905d5203.svg";
export { ForwardRef as ReactComponent };